export const billing = {
  aiUsageAudit: {
    title: 'Workspace AI and automation audit',
    loading: 'Loading audit log...',
    empty: 'No audit events yet.',
    intro:
      'Audit trail of AI and automation hooks for this workspace. Shows the latest 200 events with capability, trace, usage, and credit metadata when available.',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    noAccount: 'No workspace account found for this profile.',
    loadFailed: 'Failed to load audit events.',
    service: 'Service:',
    status: 'Status:',
    filters: {
      all: 'All',
      success: 'Success',
      error: 'Error',
      ai: 'AI',
      automation: 'Automation',
    },
    totalCredits: 'Total AI credits (filtered):',
    totalShown: 'Total shown:',
    creditUnitsLogged: 'Credit units logged (AI + automation, shown events):',
    noEventsFiltered: 'No events found for the selected filters.',
    memberTitle: 'AI usage',
    memberSubtitle: 'AI credits are shared by everyone in your workspace.',
    memberBody: 'AI usage for this workspace is reviewed by its owner. The shared credit balance is on Billing & usage.',
  },
  usage: {
    addons: {
      title: "Add-ons",
      subtitle: "Extra features you add to your plan, paid per asset.",
      loadFailed: "Add-ons could not be loaded. Try again later.",
      perAssetMonth: "{{price}} per asset a month",
      included: "Included in your plan",
      statusTrialing: "On: free trial until {{date}}",
      statusActive_one: "On for {{count}} asset: {{total}} a month",
      statusActive_other: "On for {{count}} assets: {{total}} a month",
      statusActiveNoPrice_one: "On for {{count}} asset",
      statusActiveNoPrice_other: "On for {{count}} assets",
      statusOff: "Off",
      notOnPlan: "Not on your plan. Change plan to add it (Plans shows which plans can).",
      notAvailableInApp: "Not available to buy in the app",
      adminsOnly: "Workspace admins add or turn off add-ons.",
      coverTitle: "What it covers",
      coverWhole: "Whole workspace",
      coverSites: "Chosen sites",
      coverHint: "A chosen site also covers the sites inside it.",
      noSites: "No sites yet: it covers the whole workspace.",
      liveTotal_one: "{{count}} asset × {{price}} = {{total}} a month",
      liveTotal_other: "{{count}} assets × {{price}} = {{total}} a month",
      trialNote: "Free for {{days}} days, then billed with your plan. Turn it off any time.",
      proRata: "Changes take effect today and are charged or credited pro rata on your next bill.",
      startTrial: "Start {{days}}-day free trial",
      startPaid: "Add to my plan",
      save: "Save what it covers",
      end: "Turn off",
      keep: "Keep it",
      endConfirmTitle: "Turn off {{name}}?",
      endConfirmBody: "It ends today and any unused paid time is credited on your next bill. Your ESG records are kept and come back if you turn it on again.",
      chooseSite: "Choose at least one site, or the whole workspace.",
      failed: "The add-on could not be updated. Try again.",
    },
    assistantGate: {
      debitFailedMember: "The assistant couldn't use credits for this request. Try again in a moment.",
      debitFailedAdmin: "The assistant couldn't use credits for this request. Try again, or check Billing & usage if it keeps happening.",
      debitFailedTitle: "Credits couldn't be used",
      disabledAdmin: "AI isn't included in this workspace's plan. Open Billing & usage to see plans that include it.",
      disabledMemberUnnamed: "AI isn't included in this workspace's plan. Ask your workspace owner about the plan.",
      disabledMember: "AI isn't included in this workspace's plan. Ask {{owner}} about the plan.",
      disabledTitle: "AI assistant is off",
    },
    assetGate: {
      seePlans: "See plans",
      subscriptionRequired: "Your workspace has used the free assets on its plan. Start a subscription to add more assets.",
      askOwner: "Ask the workspace owner to add a plan before more assets can be added.",
      askOwnerNamed: "Ask the owner of {{workspace}} to add a plan before more assets can be added.",
      title: "Subscription required",
    },
    checkout: {
      unavailable: "Buying isn't available right now. Try again later.",
      needsEmail: "Add an email to your profile before starting checkout.",
      contactSales: "This plan is sold through our team. Contact AssetWRX to get started.",
      notConfigured: "This plan isn't available to buy yet. Contact support.",
      generic: "We couldn't start checkout. Try again in a moment, or contact support if it keeps happening.",
    },
    store: {
      planGone: "That plan is no longer offered. Close and reopen this screen.",
      unavailable: "Store purchases aren't available in this version of the app.",
      purchaseFailed: "The purchase didn't go through. Try again.",
      ownerOnly: "Only the workspace owner can manage its store subscription.",
    },
    workAi: {
      hostFallback: "the workspace",
      settingTitle: "AI for people you work with",
      settingSubtitle: "Contractors and requesters can use AI on your jobs, inspections and assets, paid from your credits.",
      settingLabel: "Credits a month for each person",
      settingHelper: "Leave blank for the standard allowance. 0 turns it off.",
      settingPlaceholder: "Standard",
      settingInvalid: "Enter a whole number, or leave it blank.",
      settingSave: "Save",
      settingSaved: "Saved",
      settingFailed: "Could not save the allowance",
      usedTitle: "{{host}}'s AI for this month is used up",
      offTitle: "{{host}} does not include AI on its work",
      useOwnBody: "You can use your own AI credits for this instead.",
      notNow: "Not now",
      useOwn: "Use my credits",
      refused: "{{host}}'s AI for this month is used up.",
    },
    aiGate: {
      freePeriodEnded: "AI is paused because the free period has ended and this workspace is read-only.",
      pastDue: "AI is paused because of a payment failure. Update billing to turn it back on.",
      canceled: "AI is off because this workspace's subscription was cancelled.",
      notEnoughCredits_other: "This needs {{count}} AI credits and your workspace doesn't have enough.",
      notEnoughCredits_one: "This needs {{count}} AI credit and your workspace doesn't have enough.",
      readOnly: "AI is paused because this workspace is read-only.",
      notInPlan: "AI isn't included in this workspace's plan.",
      checkFailed: "We couldn't check your AI credits. Try again.",
    },
    creditCode: {
      refund: "Refund",
      adjustment: "Adjustment",
      included: "Included credits",
      purchase: "Purchase",
      topUp: "Top-up",
      aiCredits: "AI credits",
      aiUsage: "AI usage",
    },
    packCredits_other: "{{count}} credits",
    packCredits_one: "{{count}} credit",
    planLoadFailed: "Couldn't load your plan.",
    ownerManagesUnnamed: "Your workspace owner manages the plan and credits for this workspace.",
    ownerManages: "{{owner}} manages the plan and credits for this workspace.",
    confirmationAwaitingBody: "Finish paying in the checkout window, then come back here. Tap Refresh if your plan and credits haven't updated.",
    confirmationAwaitingTitle: "Waiting for your checkout",
    paymentStatusInactiveDetailMember: "There is no active subscription. Your workspace owner can start one.",
    paymentStatusPausedDetailMember: "The subscription is paused. Your workspace owner can resume it.",
    paymentStatusPastDueDetailMember: "A payment is overdue. Your workspace owner can fix it in Billing & usage.",
    statusFreePeriodEndedMember: "The free period has ended and the workspace is read-only. Your workspace owner can choose a plan; nothing has been deleted.",
    statusFreeLimitReachedMember: "The free limit is reached. Your workspace owner can choose a plan to add more assets.",
    statusFreeUntilMember: "Free until {{date}}. Your workspace owner chooses the plan.",
    statusFreeFirstAsset_other: "Your plan includes {{count}} free assets. Billing starts when you add more.",
    statusFreeFirstAsset_one: "Your plan includes {{count}} free asset. Billing starts when you add the next one.",
    creditsNeeded_other: "This needs {{count}} credits and you have {{balance}}.",
    creditsNeeded_one: "This needs {{count}} credit and you have {{balance}}.",
    continueWithoutAi: "Continue without AI",
    outOfCreditsOk: "OK",
    outOfCreditsNeutral: "Your workspace has run out of AI credits. You can keep working without AI.",
    outOfCreditsMemberBodyUnnamed: "You can keep working without AI. Ask your workspace owner to add credits.",
    outOfCreditsMemberBody: "You can keep working without AI. Ask {{owner}} to add credits.",
    outOfCreditsAdminBodyNoBuy: "You can keep working without AI.",
    outOfCreditsAdminBody: "You can keep working without AI, or buy a credit pack.",
    title: 'Billing & usage',
    intro: 'Review subscription health, credits, and next billing actions.',
    summaryIntro: 'Your plan, credits, and billing.',
    outOfCreditsTitle: "AI credits have run out",
    outOfCreditsBody: 'AI actions need credits. Buy a credit pack to keep going, or wait for your monthly included credits.',
    outOfCreditsNotNow: 'Not now',
    trialCapTitle: 'Above your trial limit',
    creditPackPickerTitle: 'Choose a credit pack',
    creditPackPickerSubtitle: 'Credits never expire.',
    buyCreditsCta: 'Buy',
    cancel: 'Cancel',
    kpiSectionTitle: 'Usage snapshot',
    kpiSectionHint: 'What you are billed for, and the AI credits you have.',
    kpiAssetsTitle: 'Billable assets',
    kpiAssetsBody: 'Active assets billed this cycle.',
    kpiMonthlyPlanTitle: 'Plan credits',
    kpiMonthlyPlanBody: 'Credits included each month.',
    kpiMonthlyPlanBodyUnlimited: 'Monthly credits are unlimited.',
    kpiPurchasedTitle: 'Purchased credits',
    kpiPurchasedBody: 'Top-up credits still available.',
    kpiRemainingTitle: 'Credits left',
    kpiRemainingBody: 'Included + purchased credits left.',
    kpiRemainingBodyUnlimited: 'Credits are unlimited for this workspace.',
    loading: 'Loading billing...',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    noAccount: 'No workspace account found for this profile.',
    loadFailed: 'Failed to load billing data.',
    billingDataMissing: 'Billing data could not be displayed. Try refreshing.',
    errorTitle: 'Billing data is unavailable',
    emptyTitle: 'Billing needs a workspace',
    emptyBody: "Billing belongs to a workspace. Switch to a workspace to see its plan, credits and invoice currency.",
    planTitle: 'Subscription',
    unlimited: 'Unlimited',
    subscriptionSummaryTitle: 'Subscription summary',
    subscriptionSummarySubtitle: 'Provider-backed status and renewal timing for this workspace.',
    managedOnWeb: 'Plan and credit changes are not available in this app.',
    statusFreeUntil: "Free until {{date}}. Choose a plan to keep your workspace working after that.",
    internalEditionName: "Developer (internal test edition)",
    statusInternalEdition: "Internal test edition: every feature is on and nothing is billed. Set in Admin only.",
    statusGranted: "Your plan is provided at no charge, with no end date.",
    statusGrantedUntil: "Your plan is provided at no charge until {{date}}. Choose a plan before then to keep your workspace working.",
    statusFreeFirstAsset: "No charge yet. Billing starts when you add more assets than your plan includes free.",
    statusFreeLimitReached: "Your free limit is reached. Choose a plan to add more assets.",
    statusFreePeriodEnded: "Your free period has ended and your workspace is read-only. Choose a plan to keep working; nothing has been deleted.",
    statusActive: "Your subscription is active.",
    statusActiveRenews: "Your subscription is active and renews on {{date}}.",
    statusActiveEnds: "Your subscription is cancelled and ends on {{date}}. You keep your plan until then.",
    statusBilledByStore: "Your subscription is billed through the app store. Manage it there.",
    changePlanHint: "Move to another plan; the change is confirmed before anything is charged.",
    cancelSubscription: "Cancel subscription",
    cancelSubscriptionHint: "Your plan stays until the end of the paid period; nothing more is charged.",
    resumeSubscription: "Resume subscription",
    resumeSubscriptionHint: "Keep your plan; it renews as before.",
    cancelSubscriptionConfirmTitle: "Cancel your subscription?",
    cancelSubscriptionConfirmBody: "You keep {{plan}} until {{date}}; nothing more is charged. You can resume any time before then.",
    cancelSubscriptionConfirmBodyNoDate: "You keep {{plan}} until the end of the current period; nothing more is charged. You can resume any time before then.",
    cancelSubscriptionKeep: "Keep my plan",
    cancelSubscriptionConfirm: "Cancel subscription",
    cancelSubscriptionError: "Could not change your subscription.",
    planReference: '{{plan}} billing',
    paymentStatusLabel: 'Payment status',
    paymentStatusFreeDetail: "No charge yet. Billing starts when you add more assets than your plan includes free.",
    paymentStatusGrantedDetail: "Provided at no charge. Nothing is billed.",
    paymentStatusSubscriptionRequiredDetail: 'Free limit reached. Start a subscription to continue adding active assets.',
    paymentStatusStripeDetail: 'Billing is active for this workspace.',
    paymentStatusPastDueDetail: 'Payment is past due. Resolve it in the billing portal to avoid service disruption.',
    paymentStatusPausedDetail: 'Subscription is paused. Resume billing before adding more active assets.',
    paymentStatusInactiveDetail: 'No active collection. Start or restore a subscription to continue billing.',
    paymentStatusInternalDetail: "Billing is not fully set up for this workspace yet, so this is the latest status we have.",
    renewalDateLabel: 'Renewal date',
    renewalKnownDetail: 'Based on the latest synced subscription period end.',
    renewalUnknownDetail: 'Renewal timing is not available yet for this workspace.',
    lastTrueUpLabel: "Assets last counted",
    trueUpKnownDetail: "When your active assets were last counted for billing.",
    trueUpUnknownDetail: "Your assets haven't been counted for billing yet.",
    presentmentCurrencyLabel: "Invoice currency",
    presentmentCurrencyBadge: '{{currency}} billing',
    currencyUnknown: 'Unknown',
    currencyPresentmentNote: "Prices are set in {{currency}}. Your invoice may show your local currency.",
    currencyCatalogOnlyNote: "Prices and invoices are in {{currency}}.",
    editionTitle: 'Your plan',
    editionSubtitle: "Your plan sets which features are available. Assets and AI credits are billed separately.",
    monthlyAmountTitle: 'Estimated monthly amount',
    monthlyAmountSubtitle: "Your invoice shows the final total.",
    amountFinal: 'Final amount',
    amountEstimated: 'Estimated amount',
    amountUnavailable: 'Amount unavailable',
    amountFinalExplanation: 'From the latest settled invoice.',
    amountEstimatedPresentmentExplanation: "An estimate. Your invoice shows the final amount, which may be in your local currency.",
    amountEstimatedCatalogExplanation: "An estimate in {{currency}}. Your invoice shows the final amount.",
    amountUnavailableExplanation: 'A reliable customer-facing amount is not available yet.',
    creditsAndAssetsTitle: 'Credits and billable assets',
    creditsAndAssetsSubtitle: 'Operational balances for usage and limits.',
    billableAssetsMetric: 'Active billable assets',
    includedMonthlyMetric: 'Included monthly credits',
    purchasedCreditsMetric: 'Purchased credits',
    totalRemainingCreditsMetric: 'Total remaining credits',
    pricingExplanationTitle: 'Pricing details',
    pricingExplanationSubtitle: 'Current billing bands from the catalog.',
    pricingSummaryKnown:
      'Graduated pricing for {{assetCount}} active billable assets, referenced in {{currency}}.',
    pricingSummaryUnknown:
      'No structured pricing bands are available from the billing catalog yet, so the UI cannot provide a safe line-by-line pricing explanation.',
    pricingBandOpenEnded: '{{min}}+ assets',
    pricingBandRange: '{{min}} to {{max}} assets',
    pricingBandLabel: '{{label}}',
    pricingBandUnknown: 'Rate unavailable',
    pricingBandEmpty: 'No pricing bands are configured for this billing model yet.',
    catalogReferenceNote: 'Catalog reference currency: {{currency}}.',
    startSubscription: 'Start subscription',
    startSubscriptionHint: "Start a subscription to add more assets than your plan includes free.",
    startSubscriptionAdminOnly: "Only the workspace owner can start the subscription.",
    startSubscriptionStripeOff: "Buying isn't available right now.",
    startSubscriptionUnavailable: 'This workspace cannot start a new subscription from the current billing state.',
    manageSubscriptionHint: 'Open the billing portal to manage your subscription or payment method.',
    manageBillingAdminOnly: "Only the workspace owner can manage billing.",
    manageBillingUnavailable: 'Billing portal access is not available for this workspace yet.',
    buyMoreCredits: 'Buy credits',
    buyCreditsHint: "Buy a credit pack. One-time secure checkout.",
    buyCreditsAdminOnly: "Only the workspace owner can buy credits.",
    buyCreditsStripeOff: "Buying isn't available right now.",
    buyCreditsUnavailable: 'No credit-pack price is configured yet.',
    buyCreditsPriceHint: 'Reference catalog price: {{price}}.',
    priceUnavailable: 'Price unavailable',
    activityTitle: 'Recent credit activity',
    activitySubtitle: 'Latest credit movements (preview).',
    subscriptionDetailsTitle: 'Subscription details',
    subscriptionDetailsSubtitle: 'Operational timing and sync details.',
    currencyDetailsTitle: 'Currency details',
    currencyDetailsSubtitle: 'Presentment and catalog currency behavior.',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    ledgerEmpty: "No credit activity yet.",
    linkAudit: 'Open AI & automation audit',
    manageStripeBilling: 'Manage subscription',
    stripeCheckoutError: "Couldn't open checkout. Try again.",
    stripePortalError: "Couldn't open billing management. Try again.",
    stripeConfigOff:
      'Stripe checkout is off. In the project root `.env`, set EXPO_PUBLIC_STRIPE_BILLING_ENABLED=true, then add EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION and/or EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 (each must be a Stripe price_... ID). Restart Expo with `npx expo start --clear`.',
    stripeConfigNoPrices:
      'Stripe is enabled but no valid Price IDs were found. Use Stripe Price IDs starting with `price_` (not `prod_`). Set EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION and/or EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 in `.env`, then restart Expo.',
    confirmationConfirmedTitle: "Purchase complete",
    confirmationCancelledTitle: "Checkout cancelled",
    confirmationPendingTitle: "Finishing your purchase",
    confirmationConfirmedBody: "Done. Your plan and credits below are up to date.",
    confirmationCancelledBody: "No billing change was applied. Your existing plan and credits are unchanged.",
    confirmationPendingBody: "Payment received. Your plan and credits will update in a few seconds. Tap Refresh if they haven't.",
    trialCapBody_one: "Your trial allows {{max}}. You have {{billable}} active assets, so {{count}} asset will start being billed when your trial becomes a paid plan.",
    trialCapBody_other: "Your trial allows {{max}}. You have {{billable}} active assets, so {{count}} assets will start being billed when your trial becomes a paid plan.",
    trialCapBodyDated_one: "Your trial allows {{max}}. You have {{billable}} active assets, so {{count}} asset will start being billed when your trial ends on {{trialEnd}}.",
    trialCapBodyDated_other: "Your trial allows {{max}}. You have {{billable}} active assets, so {{count}} assets will start being billed when your trial ends on {{trialEnd}}.",
    forecastTitle: "AI credit use and forecast",
    forecastSubtitle: "How your credits were used over the last 30 days, and how long they will last.",
    consumedLast30Days: "Consumed in 30 days",
    averageDailyUse: "Average per day",
    estimatedRunway: "Credits last about",
    runwayNotLimited: "Not limited",
    runwayDays_one: "{{count}} day",
    runwayDays_other: "{{count}} days",
    ledgerReconciled: "Balance is up to date",
    ledgerPartial: "Balance is still updating",
    contactAdminTitle: "Billing is managed by the workspace owner",
    contactAdminTitleNamed: 'Plan and credits are managed by the owner of {{workspace}}',
    contactAdminSubtitle: "You can see usage here. Only the workspace owner can change the plan or buy credits.",
    viewWorkspaceAdmins: "View workspace admins",
    detailsTitle: "Billing details",
    detailsSubtitle: "Subscription, pricing, and currency.",
    chargingPolicyTitle: "How AI credits are charged",
    chargingPolicySubtitle: "What you pay for, what you don't, and what happens if something fails.",
    chargingSuccess: "You are charged once for AI that works, after you get the result.",
    chargingFailure: "Failed AI output is not charged, and manual work remains available.",
    chargingRetry: "If recording the charge fails, we retry once and never charge twice.",
    packForecastNoPattern: "Forecast impact appears after usage is recorded.",
    packForecastDays_one: "About {{count}} additional day at current use",
    packForecastDays_other: "About {{count}} additional days at current use",
  },
} as const;
